import { runInAction, toJS } from 'mobx';
/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：Home
 */
import { makeAutoObservable } from 'mobx';
import {
  getEvalutionAnswerCard,
  getEvalutionExamDetail,
  getEvalutionShow,
  getExamAnswerCard,
} from '@/store/services/evalutionService';

export class EvalutionStore {
  evaluationAnswerCard: EvalutionAnswer.AnswerCardItem[] = [];
  total = 0;
  answerList: { index: number; value: string; subject_id: string }[] = [];
  subjectIdEnumAnswer: Record<string, any> = {};
  examLinetestCard: SubjectType.SubjectOrder[] = [];
  examMajorCard: SubjectType.SubjectOrder[] = [];
  subjectCount = { linetest: '0', major: '0', evaluation: '0' };

  examDetail: ExamType.ExamDetailData = {} as unknown as ExamType.ExamDetailData;
  curExam: SubjectType.Subject = {} as unknown as SubjectType.Subject;

  constructor() {
    makeAutoObservable(this);
  }

  get noAnswerListStrings() {
    const linetest = this.examLinetestCard
      .filter((item) => item.isAnswered === 0)
      .map((item) => item.order_num)
      .join(',');
    const major = this.examMajorCard
      .filter((item) => item.isAnswered === 0)
      .map((item) => item.order_num)
      .join(',');

    console.log(toJS(major));
    return {
      linetest: linetest ? `认知能力：${linetest}` : '',
      major: major ? `专业能力：${major}` : '',
    };
  }

  setAnswer({ k, v }) {
    this.subjectIdEnumAnswer[k] = v;
  }

  setData({ key, value }: { key: keyof EvalutionStore; value: any }) {
    // @ts-ignore
    this[key] = value;
  }

  fetchExamDetail = async ({ id }) => {
    try {
      const { data } = await getEvalutionExamDetail({ id });
      if (!data) throw new Error('获取试卷详情错误');
      runInAction(() => {
        this.examDetail = data;
        this.subjectCount = data.countNum!;
      });
      return data;
    } catch (e) {
      throw e;
    }
  };

  fetchCurrentExam = async ({ exam_id, subject_id }) => {
    try {
      const { data, msg } = await getEvalutionShow({ exam_id, subject_id });
      if (!data && msg) return;
      runInAction(() => {
        this.curExam = data!.subject;
      });
      return data;
    } catch (e) {
      console.log(e);
    }
  };

  getExamAnswerCard = async ({ exam_id, type }) => {
    try {
      const { data, msg } = await getExamAnswerCard({ exam_id, type });
      if (!data && msg) return;
      runInAction(() => {
        if (type === 'linetest') this.examLinetestCard = data!;
        else this.examMajorCard = data!;
      });
      return data;
    } catch (e) {
      console.log(e);
    }
  };

  async getEvalutionAnswerCard({ exam_id, page }: { exam_id: string; page: number }) {
    try {
      const { data, total } = await getEvalutionAnswerCard({ exam_id, page });
      if (!data) return;
      runInAction(() => {
        this.evaluationAnswerCard = data;
        this.total = total;
      });
      return data;
    } catch (error) {
      console.log('error', error);
    }
  }
}

export default EvalutionStore;
